import React from "react";
import { Field, ErrorMessage } from "formik";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

function RadioButton(props) {
  const [valueRadio, setvalueRadio] = React.useState("female");

  const handleChangeRadio = (event) => {
    setvalueRadio(event.target.value);
    console.log("Radio Event: ", event.target.value);
  };

  const {
    label,
    name,
    field,
    errorobj,
    touched,
    onChange,
    blur,
    formikobj,
    ...rest
  } = props;
  return (
    <div>
      <Field id={name} name={name} label={label} {...rest}>
        {({
          field, // { name, value, onChange, onBlur }
          form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          meta,
        }) => (
          <div>
            <FormControl component="fieldset">
              <FormLabel component="legend">{label}</FormLabel>
              <RadioGroup
                aria-label={label}                
                id={name}
                name={name}
                row='true'
                value={valueRadio}
                onChange={(value) => {
                  handleChangeRadio(value);
                  formikobj.setFieldValue("radio", value);
                }}
                {...rest}
                {...field}
              >
                <FormControlLabel
                  value="female"
                  control={<Radio color="primary" />}
                  label="Female"
                />
                <FormControlLabel
                  value="male"
                  control={<Radio color="primary" />}
                  label="Male"
                />
                <FormControlLabel
                  value="other"
                  control={<Radio color="primary" />}
                  label="Other"
                />
                <FormControlLabel
                  value="disabled"
                  disabled
                  control={<Radio color="primary" />}
                  label="(Disabled option)"
                />
              </RadioGroup>
            </FormControl>

            {meta.touched && meta.error && (
              <div className="error">{meta.error}</div>
            )}
          </div>
        )}
      </Field>
    </div>
  );
}

export default RadioButton;
